export default __webpack_public_path__ + "static/media/crypto.61f6065e.svg";